import {useEffect, useState} from "react"
import {Card, Col, Row} from "react-bootstrap";
import Form from "./Form";
import {UsePost, UsePut} from "../../hooks/http";
import {useNavigate} from "react-router-dom";
import {UseMessage} from "../../hooks/UseMessage";

const Create = () => {
    const navigate = useNavigate()
    const [errors, setErrors] = useState()
    const [isLoading, setIsLoading] = useState(true)
    const [enterprises, setEnterprises] = useState([])


    const handleCreate = (PostData) => {
        UsePost(
            '/sms/upsert/',
            {data: {info: PostData}}
        ).then((response) => {
            if(response.code >= 200 && response.code <= 299){
                navigate(`/sms/${response._id}`)
                UseMessage('success', 'Sms has been successfully created')
            }else{
                setErrors(response.errors)
            }
        })
    }


    const GetEnterprises = async () => {
        return await UsePut(
            `/enterprises/get`,
            {data: {offset: 0}, toArray: true, propLabel: 'name'}
        )
    }


    useEffect(() => {
        GetEnterprises().then((response) => {
            setEnterprises(response)
            setIsLoading(false)
        })
    }, [])

    return (
        <>
            <Card>
                <Row>
                    <Col>
                        <div className="max-width-600">
                            <Form enterprises={enterprises} isReady={!isLoading} errors={errors} onSubmit={handleCreate} />
                        </div>
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export default Create